{
  "hero": {
    "title": "Faça ouro como se <em>fosse seu trabalho.<br/></em>",
    "subtitle": "Inteligência de flipping entre reinos para a casa de leilões do Retail. Dados ao vivo, apresentados como as ofertas que você realmente deve pegar — não mais um gráfico para ler.",
    "ctaPrimary": "Comece um teste grátis",
    "ctaSecondary": "Veja em ação",
    "stats": {
      "regions": "Regiões",
      "regionsValue": "EU · US",
      "updated": "Atualização",
      "updatedValue": "A cada hora"
    }
  },
  "toolsSection": {
    "label": "Ferramentas",
    "sectionTitle": "Seis instrumentos. Um objetivo: ouro.",
    "watchDemo": "Ver demo",
    "tags": {
      "flippingTool": "Entre reinos",
      "dropshipTool": "Mercados vazios",
      "realmStats": "Dados",
      "tsmListGenerator": "Exportar TSM",
      "snipeAlerts": "Tempo real",
      "inventoryAnalysis": "Escanear bolsa"
    }
  },
  "tools": {
    "flippingTool": {
      "title": "Ferramenta de Flipping",
      "description": "Ferramenta de flipping entre reinos que analisa as melhores ofertas para um item.",
      "videoTitle": "Ferramenta de Flipping Entre Reinos",
      "features": {
        "0": "Encontre a melhor oferta para um item com base em dados ao vivo.",
        "1": "Selecione reinos específicos em que deseja comprar e vender.",
        "2": "Mostra o lucro em ouro entre o reino de compra e o de venda.",
        "3": "Calcula o % de lucro para a média de venda vs. compra e venda vs. compra.",
        "4": "Mostra exatamente de qual reino/cluster de reinos comprar e em qual vender.",
        "5": "Filtros/ordenação para diferentes tipos de itens e estatísticas de preço"
      }
    },
    "dropshipTool": {
      "title": "Ferramenta de Dropship",
      "description": "Ferramenta de dropship que mostra quais itens não estão listados em um servidor para que você possa fazer flip sem concorrência.",
      "videoTitle": "Ferramenta de Dropship",
      "features": {
        "0": "Encontre o melhor servidor para vender sem concorrência",
        "1": "Selecione reinos específicos em que deseja comprar e vender.",
        "2": "Mostra o lucro em ouro entre o reino de compra e o de venda.",
        "3": "Calcula o % de lucro para a média de venda vs. compra e venda vs. compra.",
        "4": "Mostra exatamente de qual reino/cluster de reinos comprar e em qual vender.",
        "5": "Filtros/ordenação para diferentes tipos de itens e estatísticas de preço"
      }
    },
    "realmStats": {
      "title": "Estatísticas do Reino",
      "description": "Informações estatísticas sobre cada reino, preços e informações de leilões. Isso pode ajudá-lo a decidir onde comprar e onde vender.",
      "videoTitle": "Estatísticas do Reino",
      "features": {
        "0": "Encontre informações de preços sobre cada reino",
        "1": "Veja quais servidores vendem caro ou barato"
      }
    },
    "tsmListGenerator": {
      "title": "Gerador de Listas TSM",
      "description": "Ferramenta avançada de geração de listas TSM para criar listas de itens personalizadas baseadas em dados.",
      "videoTitle": "Gerador de Listas TSM",
      "features": {
        "0": "Use múltiplas fontes de preço para filtrar os melhores itens",
        "1": "Crie a lista TSM perfeita baseada em uma ampla gama de dados.",
        "2": "Exporte sua lista TSM personalizada com 1 clique."
      }
    },
    "snipeAlerts": {
      "title": "Alertas de Snipe",
      "description": "Receba notificação no momento em que itens subprecificados, pets ou BoEs de ilvl aparecerem na casa de leilões — antes que mais alguém os pegue.",
      "videoTitle": "Prévia de Alertas de Snipe",
      "features": {
        "0": "Monitore itens, mascotes de batalha e BoEs ilvl abaixo do seu preço alvo.",
        "1": "Receba DM no Discord ou webhooks instantâneos quando um snipe for encontrado.",
        "2": "Configure limites por item com uma interface simples e limpa."
      }
    },
    "inventoryAnalysis": {
      "title": "Análise de Inventário",
      "description": "Cole o CSV de inventário do seu addon FlipQueue para ver instantaneamente quais itens valem a pena flipar entre reinos. Use o resultado no addon para listar nos melhores servidores.",
      "videoTitle": "Análise de Inventário",
      "features": {
        "0": "Analise seu inventário atual contra preços ao vivo entre reinos.",
        "1": "Detecte instantaneamente quais itens em suas bolsas são lucrativos para flipar."
      }
    }
  },
  "edge": {
    "label": "A vantagem",
    "sectionTitle": "Por que os membros mantêm a assinatura.",
    "items": {
      "0": {
        "title": "Mais ouro.",
        "body": "Mostramos os flips de maior margem por minuto de esforço. Seu ouro-por-hora é o número que otimizamos."
      },
      "1": {
        "title": "Recupere suas noites.",
        "body": "Horas de varreduras TSM colapsam em uma interface pesquisável. Filtre, ordene, exporte uma lista TSM, pronto."
      },
      "2": {
        "title": "Comece hoje à noite.",
        "body": "Sem planilhas, sem complicações com addons. A maioria dos membros faz o primeiro flip lucrativo no primeiro dia."
      }
    }
  },
  "reviews": {
    "label": "Avaliações",
    "sectionTitle": "O que dizem nossos membros.",
    "videoTitle": "Avaliações de membros do FlippingPal"
  },
  "pricing": {
    "label": "Assinatura",
    "sectionTitle": "Uma assinatura. Todas as ferramentas.",
    "subtitle": "A assinatura dá acesso a todas as ferramentas do Flipping Pal"
  },
  "faq": {
    "label": "Perguntas",
    "sectionTitle": "Perguntas frequentes.",
    "items": {
      "0": {
        "question": "Tenho acesso a todas as ferramentas com a assinatura mensal?",
        "answer": "Sim, você terá acesso completo a todas as ferramentas do Flipping Pal."
      },
      "1": {
        "question": "Em qual região do WoW funciona?",
        "answer": "Tanto em US (NA) quanto em EU (Europa)."
      },
      "2": {
        "question": "Posso cancelar minha assinatura a qualquer momento?",
        "answer": "Sim, você pode cancelar sua assinatura a qualquer momento. Após o cancelamento, você perderá o acesso às ferramentas."
      },
      "3": {
        "question": "Quais métodos de pagamento são aceitos?",
        "answer": "Qualquer cartão de débito/crédito."
      },
      "4": {
        "question": "Se eu tiver alguma dúvida, receberei ajuda?",
        "answer": "Sim, se tiver dúvidas, pergunte à equipe no Discord."
      }
    }
  },
  "modal": {
    "close": "Fechar"
  },
  "backToTop": "Voltar ao topo",
  "footerCta": {
    "joinAsAffiliate": "Torne-se um afiliado",
    "contactUs": "Fale conosco",
    "discord": "Discord",
    "refundPolicy": "Política de reembolso",
    "privacyPolicy": "Política de privacidade",
    "termsAndConditions": "Termos e condições",
    "copyright": "© 2026 Flipping Pal - Todos os direitos reservados. Por",
    "creatorLabel": "Boophie (Content Creator)"
  }
}
